import PhotoDisplay from './PhotoDisplay';

export default PhotoDisplay;
